import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, HiddenVisually, Icon, Image, Popover, Stack, Text, useTheme } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import styles from "./GeniusAirlinesBanner.module.css";
import { Trans, t, useI18n } from "@bookingcom/lingojs-react";
import useGeniusAirlinesBannerEvent from "../../../hooks/c360/useGeniusAirlinesBannerEvent.js";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import web_flights_lve_deal_landing_page from "../../../utils/experiments/lve/web_flights_lve_deal_landing_page.js";
import { getDealsEntryPointUrl } from "./dealsEntryPointUrl.js";
const GeniusAirlinesBanner = (props) => {
    const { geniusAirlineBannerData, isSecondaryOffer, showDealsEntryPoint = false } = props;
    const airlines = geniusAirlineBannerData.airlines;
    const theme = useTheme();
    const i18n = useI18n();
    const { createUrlWithApiPrefix } = useCreateUrl();
    const { search } = useLocation();
    const dealsEntryPointUrl = getDealsEntryPointUrl(search);
    const trackGeniusAirlinesBannerEvent = useGeniusAirlinesBannerEvent();
    useEffect(() => {
        trackGeniusAirlinesBannerEvent(airlines.map((airline) => airline.iataCode));
    }, [trackGeniusAirlinesBannerEvent, airlines]);
    const tooltipLabel = i18n.trans(t("flights_lve_airline_promotions_genius_tooltip"));
    const [isExtraSmall, setIsExtraSmall] = useState(false);
    useEffect(() => {
        const checkWidth = () => {
            setIsExtraSmall(window.innerWidth < 360);
        };
        checkWidth();
        window.addEventListener("resize", checkWidth);
        return () => window.removeEventListener("resize", checkWidth);
    }, []);
    const carriersList = (React.createElement(Stack, { direction: "row", wrap: "wrap", className: styles.carriersListWrapper, justifyContent: isSecondaryOffer ? "start" : "end", gap: isSecondaryOffer ? 2.3 : 3, attributes: { role: "list" } }, airlines.map(({ name, imageUrl }) => !!name &&
        !!imageUrl && (React.createElement(Stack.Item, { key: name, className: !isSecondaryOffer
            ? styles.airlinesLogoWrapperAsPrimaryOffer
            : styles.airlinesLogoWrapperAsSecondaryOffer, attributes: { role: "listitem" } },
        React.createElement(Stack, { direction: "column", justifyContent: "space-between", alignItems: "center", gap: 2 },
            React.createElement(Image, { width: "32px", src: imageUrl, "aria-hidden": "true", alt: "" }),
            React.createElement(Text, { variant: "small_2", wrap: "balance", maxLines: 1, bidirectional: true }, name)))))));
    const popoverComponent = (React.createElement(Popover, { position: "top-start", triggerType: "hover", navigationMode: "tab", hideClose: true, keepMounted: true },
        React.createElement(Popover.Trigger, null, (attrs) => (React.createElement("span", { tabIndex: 0, ...attrs, role: "tooltip", "aria-label": tooltipLabel },
            React.createElement(Icon, { svg: InfoSignIcon, size: "smallest", color: "neutral_alt", className: styles.tooltip__icon__wrapper, attributes: { "aria-hidden": true } })))),
        React.createElement(Popover.Content, { attributes: {
                "aria-label": tooltipLabel,
                id: "genius_airlines_tooltip",
                role: "tooltip"
            } },
            React.createElement(Text, { variant: "body_1" }, tooltipLabel))));
    return (React.createElement(Stack, { direction: !isSecondaryOffer ? "row" : "column", gap: 3, className: styles.container, alignItems: !isSecondaryOffer ? "center" : "start", justifyContent: "space-between" },
        React.createElement(Stack.Item, null,
            React.createElement(Stack, { direction: "row", justifyContent: "start", gap: 4, alignItems: "center" },
                !isSecondaryOffer && !isExtraSmall && (React.createElement(Stack.Item, null,
                    React.createElement(Image, { height: "64px", width: "64px", contentMode: "fit", asset: {
                            setName: "illustrations-traveller",
                            assetName: "GeniusFlightsBadge"
                        } }))),
                React.createElement(Stack.Item, { className: styles.bannerText },
                    React.createElement(Text, { variant: "strong_1" },
                        React.createElement(HiddenVisually, { tagName: "h3" },
                            React.createElement(Trans, { "aria-hidden": true, tag: "flights_index_genius_airline_banner_title", variables: {
                                    start_styling: "",
                                    end_styling: ""
                                } })),
                        React.createElement("span", { "aria-hidden": true },
                            React.createElement(Trans, { tag: "flights_index_genius_airline_banner_title", variables: {
                                    start_styling: "<0>",
                                    end_styling: "</0>"
                                }, components: [React.createElement("span", { key: 0, style: { color: theme.colors.color_brand_primary_background } })] })),
                        popoverComponent),
                    React.createElement(Text, { variant: "body_2", className: isSecondaryOffer ? styles.subtitle : styles.subtitleWithMaxWidth },
                        React.createElement(Trans, { tag: "flights_index_genius_airline_banner_body" })),
                    showDealsEntryPoint ? (React.createElement("div", { className: styles.dealsCta },
                        React.createElement(Button, { href: createUrlWithApiPrefix(dealsEntryPointUrl), text: i18n.trans(t("web_flights_deals_entry_point_airline_banner_link")), variant: "primary", onClick: () => web_flights_lve_deal_landing_page.goals.entry_clicked() }))) : null))),
        React.createElement(Stack.Item, null, carriersList)));
};
export default GeniusAirlinesBanner;
